<template>
  <article>
    <section class="xbed-sub-title">
      <span>值班记录报表</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>店长值班管理</BreadcrumbItem>
        <BreadcrumbItem>值班记录报表</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <section style="margin-top:20px">
      <Form inline>
        <FormItem label="日期" :label-width="60">
          <DatePicker 
            style="width:200px" 
            type="daterange" 
            format="yyyy-MM-dd" 
            :value="dateRange" 
            :clearable="false" 
            @on-change="dateRange => {changeDate(dateRange) }"
          />
        </FormItem>
        <FormItem label="城市" prop="city" :label-width="60">
          <Select style="width:180px" ref="resetSelect" v-model="search.cityId" clearable filterable>
            <Option v-for="(city, index) in allCities" :key="index" :value="city.id">{{city.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="门店" prop="chainId" :label-width="60">
          <Select style="width:180px" v-model="search.chainId" ref="chainId" clearable filterable>
            <Option v-for="hotel in allHotels" :key="hotel.sourceId" :value="hotel.sourceId">{{hotel.sourceId + '_' + hotel.sourceName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="店长" :label-width="60">
          <Input v-model="search.manager"></Input>
        </FormItem>
        <FormItem :label-width="50" label="">
          <Button type="primary" @click="searchByPrama">查询</Button>
        </FormItem>
        <FormItem :label-width="50" label="">
          <Button :loading="exportLoading" type="primary" @click="exportDutyDetail">导出值班明细</Button>
        </FormItem>
      </Form>
      
      <div style="margin: 10px;overflow: hidden">
        <Page :page-size="search.size" show-total show-sizer :current="search.page" :total="total" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
      </div>
      <Table :columns="columns" :data="list"></Table>
    </section>
    <!-- 值班记录详情-->
    <Modal v-model="modalDisplay" ref="modalDisplay" title="值班记录详情" :width="800" @on-cancel="onCloseModal" footer-hide>
      <div style="font-size: 14px">
        <div>门店：{{record.chainId + '_' + record.chainName}}</div>
        <div>日期：{{record.curDate}}</div>
      </div>  
      <div style="font-size: 14px">
        <div>总值班时长：{{record.totalDutyTime}}</div>
        <Table :columns="recordColumns" :data="dayRecords"></Table>
      </div>
    </Modal>
  </article>
</template>
  
<script>
import API from "../../api";
import Utils from "../../utils";
import Moment from 'moment';
import Config from "../../config"

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.headerENV = Utils.aliHeaderEnv(this.env);

    this.apiHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), //走阿里云需要
      'Authorization': Utils.findFromLocalStorage("Author-token"),//走阿里云需要
      // 'group': 'dev' // 开发环境直接走ip请求才需要加该参数
    }
  },
  mounted() {
    this.$Notice.config({
      top: 100
    });
    this.getQueryDatas()
    this.getDelegateRecords()
  },
  data() {
    return {
      list: [],
      searchCitise: [],
      total: 0,
      dateRange: [Moment().subtract(6, "days").format("YYYY-MM-DD"), Moment().format("YYYY-MM-DD")],
      search: {
        chainId: '',
        cityId: '',
        manager: '',
        page: 1,
        size: 20
      },
      columns: [
        {
          title: "日期",
          align: 'center',
          key: 'curDate'
        },
        {
          title: "门店",
          // width: 200,
          align: 'center',
          render: (h, param) => {
            return h('span', param.row.chainId + '_' + param.row.chainName)
          }
        },
        {
          title: "城市",
          // width: 85,
          align: 'center',
          render: (h, param) => {
            return h('span', param.row.provinceName + param.row.cityName)
          }
        },
        {
          title: "总值班时长",
          // width: 200,
          align: 'center',
          key: 'time',
          render: (h, param) => {
            return h('span', param.row.totalDutyTime)
          }
        },
        {
          title: "参与值班店长",
          // width: 200,
          align: 'center',
          render: (h, param) => {
            return h('div', param.row.managerList.map(item => {
              return h('div',{
                style: {
                  textAlign: 'left'
                }
              }, `${item.isMainManager ? '主' : '副'}：${item.userName}_${item.phone}`)
            }))
          }
        },
        {
          title: "操作",
          width: 200,
          align: 'center',
          render: (h, param) => {
            
            return h('div', [
              h('Button', {
                props: {
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.showDetail(param.row)
                  }
                }
              }, '查看详情'),
            ])
          }
        }
      ],
      record: {},
      allCities: [],
      allHotels: [],
      modalDisplay: false,
      dayRecords: [],
      recordColumns: [
        {
          title: "当日开始时间",
          width: 200,
          align: 'center',
          render: (h, param) => {
            let item = param.row;
            return h('span', Moment(item.beginDate).format('YYYY-MM-DD HH:mm:ss'))
          } 
        },
        {
          title: "当日结束时间",
          width: 200,
          align: 'center',
          render: (h, param) => {
            let item = param.row;
            return h('span', Moment(item.endDate).format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: "当日值班时长",
          width: 150,
          align: 'center',
          key: 'todayDutyTime'
        },
        {
          title: "登记店长",
          align: 'center',
          render: (h, param) => {
            let item = param.row;
            return h('span', `${item.isMainManager == 1 ? '主：' : '副：'}${item.userName}_${item.phone}`)
          } 
        },
      ],
      exportLoading: false
    };
  },
  methods: {
    searchByPrama() {
      this.search.page = 1
      this.search.size = 20
      this.getDelegateRecords()
    },
    changePage(page) {
      this.search.page = page
      this.getDelegateRecords()
    },
    changePageSize(size) {
      this.search.page = 1
      this.search.size = size
      this.getDelegateRecords()
    },

    async getQueryDatas() {
      let selectListResp = ( await API.omsAPI[this.env].php.querySelectList() ).data;
      let citys = ( await API.omsAPI[this.env].clientServer.getAllCities(this.apiHeaders) ).data;
      this.allCities = citys;
      this.allHotels = selectListResp.data.chain;
    },
   
    async getDelegateRecords() {
      try {
        let params = {
          ...this.search,
          startDate: Moment(this.dateRange[0]).format('YYYY-MM-DD'),
          endDate: Moment(this.dateRange[1]).format('YYYY-MM-DD')
        }
        let res = (await API.omsAPI[this.env].clientServer.getDutyReportList(params, this.apiHeaders)).data
        if (res) {
          this.list = res.list;
          this.total = res.total;
        }
      } catch (error) {
        console.info(error);
      }
    },

    //编辑值班状态
    async showDetail(record) {
      this.modalDisplay = true;
      this.record = record;

      this.dayRecords = (await API.omsAPI[this.env].clientServer.getDutyReportDetail({chainId: record.chainId, date: record.curDate}, this.apiHeaders)).data.reportList
    },

    onCloseModal() {
      this.modalDisplay = false;
      this.record = {};
      this.dayRecords = [];
    },

    changeDate(dateRange) {
      this.dateRange = dateRange;
    },

    /**
     * 导出
     */
    exportDutyDetail() {
      if ( !Utils.hasPermission( 'aseInfo_omsDelegateDutyExport' ) ) {
        this.$Notice.error({
            title: "提示",
            desc: '没有导出值班明细权限'
          });
        return
      }
      let gatewayUrl = `${Config[this.env].clientServerUrl.gateWayAli}api/oms/onDutyReport/export?` + 
          "startDate=" + Moment(this.dateRange[0]).format('YYYY-MM-DD') + 
          "&endDate=" + Moment(this.dateRange[1]).format('YYYY-MM-DD') + 
          "&cityId=" + `${this.search.cityId || ''}` +
          "&chainId=" + `${this.search.chainId || ''}` + 
          "&manager=" + `${this.search.manager || ''}`;
        
        
      Utils.exportAliExcelWeighting(gatewayUrl, '值班明细报表', this.apiHeaders, this.$Notice.error, this, "exportLoading")
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/delegate-management/delegate-record.vue